<template>
<div class="session-chat">
  <v-layout column align-start justify-end fill-height>
    <v-list class='chatlist'>
      <v-list-item class="chattext"
        v-for='(message, index) in messages' :key='index'>
          <strong :style='{color: solverColor(message.solverId)}'>{{ message.solver.split(' ')[0] }}:</strong>
          &nbsp;{{ message.text }}</v-list-item>
    </v-list>
    <div style="width: 100%">
      <v-textarea rows='4' class='chatinput' v-model='currentMessage' placeholder='Send a message' @keydown.enter='sendMessage' @focus="$emit('open-dialog')" @blur="$emit('close-dialog')"></v-textarea>
      <v-btn small text dark class='chatinputbutton' @click='sendMessage'>Send</v-btn>
    </div>
  </v-layout>
</div>
</template>

<script>
import SessionsService from '@/services/SessionsService'
export default {
  name: 'session-chat',
  data () {
    return {
      currentMessage: '',
      solverColors: {}
    }
  },
  props: {
    messages: Array
  },
  methods: {
    async sendMessage (event) {
      event.preventDefault()
      if (this.currentMessage === '') return

      let response = await SessionsService.sendChatMessage(this.$store.state.sessionId, {
        solverId: this.$store.state.solverId,
        authToken: this.$store.state.authToken,
        globalAuthToken: this.$store.state.globalAuthToken,
        text: this.currentMessage,
        solver: this.$store.state.solver
      })

      if (response.data.success === false) {
        alert('Error: ' + response.data.error)
      } else {
        this.currentMessage = ''
      }
    },
    solverColor (solverId) {
      if (solverId === undefined) return '#000'
      if (this.solverColors[solverId] === undefined) {
        let hash = 0
        for (let i = 0; i < solverId.length; i++) {
          hash = solverId.charCodeAt(i) + ((hash << 5) - hash)
        }
        let color = '#'
        for (let i = 0; i < 3; i++) {
          let value = (hash >> (i * 8)) & 0xFF
          color += ('00' + value.toString(16)).substr(-2)
        }
        this.solverColors[solverId] = color
      }
      return this.solverColors[solverId]
    }
  },
  watch: {
    messages () {
      this.$nextTick(() => {
        let container = document.getElementsByClassName('chatlist')[0]
        container.scrollTop = container.scrollHeight
      })
    }
  }
}
</script>

<style>
.chattext, .v-list__tile {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
  text-align: left;
  height: auto !important;
}

.chatlist {
  background-color: #fff;
  height: 50vh;
  overflow-y: auto;
}

.chatinput {
  margin: 0px;
}
.chatinputbutton {
  width: 100%;
  background: #6441a4;
  color: #fff;
  margin: 0px;
}
</style>
